import * as React from 'react';

import RelayPlanet140 from './RelayPlanet140';

export const relayPlanet140 = () => <RelayPlanet140 />;

export default {
    title: 'Illustration|RelayPlanet140',
    component: RelayPlanet140,
    parameters: {
        notes: "`import RelayPlanet140 from 'box-ui-elements/es/illustration/RelayPlanet140';`",
    },
};
